import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    // Render the widget and store the ID so we can clean it up later
    this.widgetId = turnstile.render(this.element, {
      sitekey: this.data.get("sitekey"),
      language: this.data.get("language"),
      theme: "light"
    });
  }

  disconnect() {
    // Remove the widget before Turbo caches the page
    if (typeof turnstile !== 'undefined' && this.widgetId !== undefined) {
      turnstile.remove(this.widgetId);
    }
  }
}
